export default "__VITE_ASSET__BYVttEzO__"